import { Injectable } from '@angular/core';
import { NativeStorage } from '@ionic-native/native-storage/ngx';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(
    private platform: Platform,
    private nativeStorage: NativeStorage
  ) { }


  public async save(key: string, data: any){
    if(this.platform.is("capacitor")){
      try{
        await this.nativeStorage.setItem(key, data)
      }catch (e){
        console.error(e)
      }
    }else{
      localStorage.setItem(key, JSON.stringify(data))
    }
  }

  public async load(key: string): Promise<any>{
    if(this.platform.is("capacitor")){
      try{
        return await this.nativeStorage.getItem(key)
      }catch(e){
        console.error(e)
      }
    }else{
      let token = JSON.parse(localStorage.getItem(key))
      if(token) return token
      else return ""
    }
  }

  public async remove(key: string){
    if(this.platform.is("capacitor")){
      try{
        await this.nativeStorage.remove(key)
      }catch (e){
        console.error(e)
      }
    }else{
      localStorage.removeItem(key)
    }
  }


}
